export function QpuiBreadcrumbItemDirective(): ng.IDirective {
    return {
        transclude: true,
        require: ["^qpuiBreadcrumb", "qpuiBreadcrumbItem"],
        controller: [function () {

        }],
        controllerAs: "breadcrumbItemCtrl",
        replace: true,
        template: require("./qpui-breadcrumb-item.template.html").default,
        link: (scope, element, attributes, ctrls) => {

            if (!ctrls) {
                return;
            }
            let breadcrumbCtrl = ctrls[0];
            let selfCtrl = ctrls[1];

            // 分隔符
            selfCtrl.divider = breadcrumbCtrl.divider;

        }
    }
}